var _desc, _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBuyCongratsIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "240px",
    height: "132px",
    viewBox: "0 0 240 132",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "buy-congrats-icon") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Desktop-v2",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Desktop---reserva-fin",
    transform: "translate(-265.000000, -618.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "buy-congrats-icon",
    transform: "translate(265.000000, 618.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-7",
    fill: "#FFFFFF",
    x: 0,
    y: 0,
    width: 240,
    height: 132
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-11",
    fill: "#00D174",
    opacity: 0.100000001,
    x: 71,
    y: 19,
    width: 96,
    height: 96,
    rx: 48
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Line",
    stroke: "#00D174",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    points: "100.5 70.5 113.5 83.5 143.538086 52.6181641"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBuyCongratsIcon);
export default __webpack_public_path__ + "static/media/buy-congrats-icon.7e8bf236a779304d5cae6c8d0bd9a31a.svg";
export { ForwardRef as ReactComponent };